import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Unpin = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='m3 3 18 18'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.26 16a.75.75 0 0 0 .74-.75V12.5a.75.75 0 0 0-.22-.53l-.376-.377A6.5 6.5 0 0 1 18.5 6.997V4.75A2.75 2.75 0 0 0 15.75 2h-5.5c-.97 0-1.823.502-2.313 1.261l1.11 1.148A1.25 1.25 0 0 1 10.25 3.5h5.5c.69 0 1.25.56 1.25 1.25v2.247a8 8 0 0 0 2.343 5.657l.157.157V14.5h-.692zM8.95 7.894a8 8 0 0 1-2.293 4.76l-.525-.525.525.525-.157.157V14.5h9.055l1.5 1.5H13.75v5.25a.75.75 0 0 1-1.5 0V16h-6.5a.75.75 0 0 1-.75-.75V12.5a.75.75 0 0 1 .22-.53l.376-.377A6.5 6.5 0 0 0 7.5 6.997v-.552z'
          fill='currentColor'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.973 15.45a.8.8 0 0 0 .027-.2V12.5a.75.75 0 0 0-.22-.53l-.376-.377A6.5 6.5 0 0 1 17.5 6.997V4.75A2.75 2.75 0 0 0 14.75 2h-5.5a2.74 2.74 0 0 0-1.83.697zm.247 5.83L14.94 16h-2.19v5.25a.75.75 0 0 1-1.5 0V16h-6.5a.75.75 0 0 1-.75-.75V12.5a.75.75 0 0 1 .22-.53l.376-.377a6.5 6.5 0 0 0 1.881-4.055L2.22 3.28a.75.75 0 1 1 1.06-1.06l18 18a.75.75 0 1 1-1.06 1.06'
        fill='currentColor'
      />
    )}
  </IconBase>
);
